import React, {Component} from 'react';

import SliderEditor from './sliderField/SliderEditor';
import SliderViewer from './sliderField/SliderViewer';

import './Slider.scss';

export default class SliderField extends Component {

  render() {
    const {formKey, editing, value, hideLabel} = this.props;
    const label = formKey.replace('_', ' ').toUpperCase();
    return (
      <div>
        {!hideLabel && <div className="slider-label">{label}</div>}
        {editing && <SliderEditor value={value} {...this.props}/>}
        {!editing && <SliderViewer value={value} {...this.props}/>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/technologyComfort/sliderGroup/SliderField.jsx